import {environment} from '../../../environments/environment';
import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import 'rxjs/add/operator/map';
import { RecurrenceUnit } from '@app/shared/models/enums/recurrence-unit.enum';
import { RecurrenceType } from '@app/shared/models/enums/recurrence-type.enum';

@Injectable()
export class RecurrenceService {
    static readonly API_RECURRENCE_BASE_PATH = `${environment.baseURL}/api/recurrences`;

    constructor(private http: HttpClient) {
    }

    getRecurrences(name: string) {
        const params = {
            name: name || ''
        };
        return this.http.get(`${RecurrenceService.API_RECURRENCE_BASE_PATH}`, {params: params});
    }

    create(recurrence) {
        return this.http.post(`${RecurrenceService.API_RECURRENCE_BASE_PATH}`, this.mapRecurrence(recurrence));
    }

    update(recurrence) {
        return this.http.put(`${RecurrenceService.API_RECURRENCE_BASE_PATH}/${recurrence.id}`, this.mapRecurrence(recurrence));
    }

    delete(id) {
        return this.http.delete(`${RecurrenceService.API_RECURRENCE_BASE_PATH}/${id}`);
    }


    mapRecurrence(recurrence) {
        const copyRecurrence: any = {
            id: recurrence.id,
            name: recurrence.name,
            type: recurrence.type,
            value: (recurrence.value
                && (recurrence.type === RecurrenceType.TIME || recurrence.type === RecurrenceType.CYCLE))
                ? recurrence.value : 0,

            unit: (recurrence.unit && recurrence.type === RecurrenceType.TIME) ? recurrence.unit : RecurrenceUnit.EMPTY,
        };
        return copyRecurrence;
    }
}
